import React, { useEffect, useState } from 'react'
import { ScrollPanel } from 'primereact/scrollpanel'
import { IoSearchOutline } from 'react-icons/io5'
import { FaSpinner } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { onFetchPublishTask } from '../../../../Redux/Actions/TaskCreatorAction'
import TasksCard from '../TasksCard'
import CustomPagination from '../../../Common/CusstomPagination'
import NewPagination from '../../../Common/NewPagination'

const AllTaskCreator = ({ first, url, type }) => {

    const dispatch = useDispatch()
    const [data, setData] = useState({})
    const [q, setQ] = useState('')
    const [sortOrder, setSortOrder] = useState('asc');
    const [loader, setLoader] = useState({
        fetch: true,

    })

    const [currentPage, setCurrentPage] = useState(1);
    const handlesort = () => {
        const sortedData = [...data].sort((a, b) => {
            if (sortOrder === 'asc') {
                return a.id - b.id;
            } else {
                return b.id - a.id;
            }
        });

        setData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    }



    const fetchData = () => {
        setLoader({
            ...loader,
            fetch: true
        })
        let formData = {
            "page": currentPage || 1
        }
        dispatch(onFetchPublishTask(url, formData, setData, loader, setLoader))

    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    }
    useEffect(() => {
        if (first) {
            fetchData()
        }
    }, [currentPage, first]);
    return (
        <>
            <ScrollPanel className="custombar2 creator_task content-area pt-lg-0 pt-3">
                <div className="content-area-in task_final pt-0">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="main_task_details pb-2">
                                    <div className="do_task_wrapper ">
                                        <div className="table-bar">
                                            <div className="table-bar-left">
                                                <div className="table-bar-icon">
                                                    <div className="table-nav">
                                                        <div className="profile-menu">

                                                        </div>

                                                    </div>


                                                    <ul>
                                                        <li title="Sort by Date" onClick={handlesort}>
                                                            <img src={require("../../../../images/icon/sort.svg").default} alt="" />
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="table-bar-right">
                                                <div className="header-search">
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        value={q}
                                                        onChange={(e) => setQ(e.target.value)}
                                                    />
                                                    <span className="left-icon"><IoSearchOutline
                                                    /></span>
                                                </div>
                                            </div>
                                        </div>



                                        {loader.fetch ? <FaSpinner className='spin ms-1 w-100 d-flex mt-4' style={{ fontSize: "40px" }} /> :
                                            <>
                                                {data.length > 0 ? data.filter((curElem) => curElem.title.toLowerCase().includes(q.toLowerCase())).length > 0 ?

                                                    data.filter((curElem) => curElem.title.toLowerCase().includes(q.toLowerCase())).map((curlElem, index) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <TasksCard
                                                                    curlElem={curlElem}
                                                                    fetchPublishTask={fetchData}
                                                                    type={type}
                                                                />
                                                            </React.Fragment>
                                                        )
                                                    })
                                                    : <p style={{ textAlign: "center", marginTop: "30px" }}>No search task </p> : <p style={{ textAlign: "center", marginTop: "30px" }}>No {type === "alltask" ? "all" : type === "pending" ? "pending" : type === "approved" ? "approved" : type === "rejected" ? "rejected" : ""} task </p>}
                                            </>

                                        }

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-end my-4 me-5'>
                    <NewPagination
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                        data={data}
                        loader={loader.fetch}
                    />


                </div>
                {/* <div style={{ marginBottom: "50px" }} className=''>
                    <CustomPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        totalLength={totalLength}
                        loader={loader.fetch}
                    />

                </div> */}
            </ScrollPanel >

        </>
    )
}

export default AllTaskCreator
